module.exports = __webpack_public_path__ + "fonts/StdKaiXHYL1EG-Md.svg";